import { fbDatabase} from 'src/boot/firebase'
import { useUserStore } from 'src/stores/store-user'

export function logIt (params) {
  if(import.meta.env.DEV) console.log('logIt', {params});

  let payload = params || {}
  payload.uid = useUserStore().uid
  if(!payload.uid) return

  payload.date = new Date().toISOString()
  fbDatabase.ref('logs').push(payload);
}
